import React from 'react'

import useStyles from './styles'
import { Grid, Typography } from '@material-ui/core'
import { BsDownload } from 'react-icons/bs'

const DownloadLinks = ({ links, light }) => {
  const { link, wrapper } = useStyles({ light })

  const internalLinks = links.filter((e) => !e.external)
  const externalLinks = links.filter((e) => e.external)

  return (
    <Grid container direction="column" className={wrapper}>
      {externalLinks.map((item, index) => {
        return (
          <a
            key={index}
            href={item.path}
            target="_blank"
            rel="noopener noreferrer"
            className={link}
          >
            <Grid container>
              <Grid item xs={11}>
                <Typography>{item.title}</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography>
                  <BsDownload />
                </Typography>
              </Grid>
            </Grid>
          </a>
        )
      })}

      {internalLinks.map((item, index) => {
        return (
          <a key={index} href={item.path} className={link} download>
            <Grid container>
              <Grid item xs={11}>
                <Typography>{item.title}</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography>
                  <BsDownload />
                </Typography>
              </Grid>
            </Grid>
          </a>
        )
      })}
    </Grid>
  )
}

export default DownloadLinks
